import { render, staticRenderFns } from "./dialA04.vue?vue&type=template&id=c4c6dc42&"
import script from "./dialA04.vue?vue&type=script&lang=js&"
export * from "./dialA04.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "dialA04.vue"
export default component.exports